import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CamModelDayState } from './CamModelDay.types';

const initialState: CamModelDayState = {
    status: 'initial',
    errorMessage: '',
    amount: 0,
    awardPerAmount: 0,
    desiredAmount: 0,
    earnedAward: 0,
};

const camModelDaySlice = createSlice({
    name: 'camModelDay',
    initialState,
    reducers: {
        fetchCamModelDayStarted: (state) => {
            state.status = 'pending';
            state.errorMessage = '';
        },
        fetchCamModelDaySucceeded: (
            state,
            action: PayloadAction<{
                amount: number;
                awardPerAmount: number;
                desiredAmount: number;
                earnedAward: number;
            }>,
        ) => {
            state.status = 'resolved';
            state.errorMessage = '';
            state.amount = action.payload.amount;
            state.awardPerAmount = action.payload.awardPerAmount;
            state.desiredAmount = action.payload.desiredAmount;
            state.earnedAward = action.payload.earnedAward;
        },
        fetchCamModelDayFailed: (state, action: PayloadAction<string>) => {
            state.status = 'rejected';
            state.errorMessage = action.payload;
        },
    },
});

export const { fetchCamModelDayStarted, fetchCamModelDaySucceeded, fetchCamModelDayFailed } = camModelDaySlice.actions;
export default camModelDaySlice.reducer;
